@if (crumbs()?.length) {
<nav class="sn-breadcrumb" aria-label="Breadcrumb">
  <ol class="sn-breadcrumb__list sn-breadcrumb__list--full">
    @for (crumb of head; track trackByLabel($index, crumb)) {
      <ng-container *ngTemplateOutlet="item; context: {$implicit: crumb}"></ng-container>
    }
    @if (folded) {
    <li class="sn-breadcrumb__item sn-breadcrumb__more">
      <button type="button" class="sn-breadcrumb__more-button" [attr.aria-label]="'Show ' + hidden.length + ' more'"
              [title]="hiddenLabels" (click)="expanded = true">…</button>
    </li>
    }
    @for (crumb of tail; track trackByLabel($index, crumb)) {
      <ng-container *ngTemplateOutlet="item; context: {$implicit: crumb}"></ng-container>
    }
  </ol>

  <!-- A phone: the way back to the parent, and the page's own name. -->
  <div class="sn-breadcrumb__compact">
    @if (parent) {
    <a class="sn-breadcrumb__back" [routerLink]="parent.path" [queryParams]="parent.queryParams"
       [attr.aria-label]="'Back to ' + parent.label">
      <i class="fa-solid fa-chevron-left" aria-hidden="true"></i>
    </a>
    }
    <span class="sn-breadcrumb__current" aria-current="page">{{ current?.label }}</span>
  </div>

  <ng-template #item let-crumb>
    <li class="sn-breadcrumb__item">
      @if (crumb.path && !crumb.current) {
      <a class="sn-breadcrumb__link" [title]="crumb.label"
         [routerLink]="crumb.path" [queryParams]="crumb.queryParams">{{ crumb.label }}</a>
      } @else {
        <span class="sn-breadcrumb__text" [class.sn-breadcrumb__text--current]="crumb.current" [title]="crumb.label"
              [attr.aria-current]="crumb.current ? 'page' : null">{{ crumb.label }}</span>
      }
    </li>
  </ng-template>
</nav>
}
